import { useCallback, useEffect, useRef, useState } from 'react';

/** Whole-second countdown. start(n) (re)arms it; `left` hits 0 and stays there. */
export default function useCountdown() {
  const [left, setLeft] = useState(0);
  const timer = useRef(null);

  const stop = useCallback(() => {
    if (timer.current) clearInterval(timer.current);
    timer.current = null;
  }, []);

  const start = useCallback((seconds) => {
    stop();
    setLeft(seconds);
    if (seconds <= 0) return;
    timer.current = setInterval(() => {
      setLeft((s) => {
        if (s <= 1) {
          clearInterval(timer.current);
          timer.current = null;
          return 0;
        }
        return s - 1;
      });
    }, 1000);
  }, [stop]);

  useEffect(() => stop, [stop]);
  return { left, start, stop };
}
